import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';


import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-lichhocedit',
  templateUrl: './lichhocedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./lichhocedit.component.scss'],
    providers: [ListService, Repository]
})


export class lichhoceditComponent implements OnInit {
  inputphonghocs: any;
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, LopId: null, Thu: null
    , TuNgay: null, DenNgay: null, GhiChu: null
    ,Created: null, Modified: null, CreatedBy: null, ModifiedBy: null

  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputthus: any = [
    { Ten: 'Thứ 2', Id: 2 },
    { Ten: 'Thứ 3', Id: 3 },
    { Ten: 'Thứ 4', Id: 4 },
    { Ten: 'Thứ 5', Id: 5 },
    { Ten: 'Thứ 6', Id: 6 },
    { Ten: 'Thứ 7', Id: 7 },
    { Ten: 'Chủ nhật', Id: 8 }
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  @ViewChild('mdChonDoiTuongChung') mdChonDoiTuongChung: BsModalComponent;
  @ViewChild('dtechondoituongchungedit') dtechondoituongchungedit: any;
  
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
 
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata : any, lopid: string) {

    
    this.tieudectmtplace = "Ghi chú";
    this.tieudectmt = "Ghi chú";

      this.hoatdong = "Hoạt động"

          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].Them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].Sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].Xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }

            

          }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
    }, 500);
    

    this.repo.getRequest("api/hocvien/getcombophonghoc/", { donviid: this.currentUser.id_don_vi })
      .subscribe(response => {
        this.inputphonghocs = response.data;

      });  

    this.doituongSelect = {
      Id: null, LopId: null, Thu: null
      , TuNgay: null, DenNgay: null, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , PhongHocId: null

    };    
    if (id === null)
    {
      

      this.doituongSelect.TuNgay = new Date();
      this.doituongSelect.DenNgay = new Date();
      this.doituongSelect.LopId = lopid;
          this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = this.currentUser.user_name;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;
         
          
    }
        else {
      console.log("t11");
      this.repo.postRequest("api/lichhoc/getbyid/", { IdGuid: id, NhomDoiTuongId: nhomdoituongid, UserName: this.currentUser.user_name })
            .subscribe(response => {  
                console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.LopId = lopid;
              this.doituongSelect.Thu = response.Thu;
              this.doituongSelect.GhiChu = response.GhiChu;
              this.doituongSelect.PhongHocId = response.PhongHocId;
              
              this.doituongSelect.Created = response.Created;
              this.doituongSelect.CreatedBy = response.CreatedBy;
              this.doituongSelect.Modified = new Date();

              if (response.TuNgay != null)
                this.doituongSelect.TuNgay= new Date(response.TuNgay);
              else
                this.doituongSelect.TuNgay = null;
              
              if (response.DenNgay != null)
                this.doituongSelect.DenNgay = new Date(response.DenNgay);
              else
                this.doituongSelect.DenNgay = null;
           
            }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    if (this.doituongSelect.Thu == null || this.doituongSelect.Thu == "") {
      swal('Lỗi!', 'Vui lòng nhập thứ!.', 'error');
      return;
    }
    if (this.doituongSelect.TuNgay == null || this.doituongSelect.TuNgay == "") {
      swal('Lỗi!', 'Vui lòng nhập Từ giờ!.', 'error');
      return;
    }
    if (this.doituongSelect.DenNgay == null || this.doituongSelect.DenNgay == "") {
      swal('Lỗi!', 'Vui lòng nhập đến giờ!.', 'error');
      return;
    }
    

    //console.log("save_ttt");
    //console.log(this.doituongSelect);
    $('#loading').show();
    this.repo.postRequest("api/lichhoc/addorupdate",this.doituongSelect)
            .subscribe(response => {  
              $('#loading').hide();
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;


   


}
